import { Component, OnInit, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {Aide} from '../../../class/api/Aide';
import {Observable} from 'rxjs';
import {api} from '../../../api/api-dictionnary';
import {ToolsService} from '../../services/tools/tools.service';
import {CommissionSeance} from '../../../class/api/CommissionSeance';
import {map} from 'rxjs/operators';
import {LocalStorage} from 'ngx-webstorage';
import {DossierChangementCommissionSeanceRequest} from '../../../class/api/DossierChangementCommissionSeanceRequest';
import {ExDossier} from '../../../class/ex/ex-dossier';
import {Utilisateur} from '../../../class/api/Utilisateur';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { UpperCasePipe, DatePipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-changer-commission',
    templateUrl: './modal-changer-commission.component.html',
    styleUrls: ['./modal-changer-commission.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatSelect, FormsModule, MatOption, MatDialogActions, MatDialogClose, MatButton, UpperCasePipe, DatePipe, TranslateModule]
})
export class ModalChangerCommissionComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalChangerCommissionComponent>>(MatDialogRef);
    private hydraService = inject(HydraService);
    private toolService = inject(ToolsService);
    data = inject<ExDossier>(MAT_DIALOG_DATA);

    public now: Date = new Date();
    public aide: Aide = null;
    public commissionSeanceSelected = null;
    public commissionSeances = []; // Commission seance sans celle de du dossier courant
    public justification: string = null;
    public commissionDepasse: Boolean = false;
    public candidat: Utilisateur = null;

    public dossier?:ExDossier = null;
    @LocalStorage() public dateShort;


    ngOnInit() {
        if(typeof this.data === 'string'){
            this.hydraService.getItem(this.data).subscribe(
                (res) => {
                    this.initData(new ExDossier(res))
                }
            )
        }else{
            this.initData(
                new ExDossier(this.data)
            );
        }
    }

    public getCommissionSeance() {
        const csDossierListe = this.dossier.commissionSeances;

        // On veut toutes les CS de l'aide sauf celle du dossier
        this.commissionSeances = this.aide.commissionSeances.filter(
            (csAide: CommissionSeance) => {
                let pass = false;
                if (
                    (csAide.commission.commissionType.code === 'CN' || csAide.commission.commissionType.code === 'ADHOC') &&
                    new Date(csAide.datetimeDebut) >= new Date()
                ) {
                    pass = true;
                }
                if (pass) {
                    csDossierListe.map(csDossier => {
                        if (csDossier['id'] == csAide['id']) {
                            pass = false;
                        }
                    });
                }

                return pass;
            }
        );
    }

    public getAide(url: string): Observable<Aide> {
        return this.hydraService.getItem(url).pipe(
            map((res: Aide) => res as Aide)
        );
    }

    public compareByid(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne.id == itemTwo.id;
    }

    public changerCommission() {
         const payload = new DossierChangementCommissionSeanceRequest(
            {
                commissionSeance: this.commissionSeanceSelected['@id'],
                commissionSeanceQuittee: this.dossier.getCommissionSeanceExpertise() ?? null,
                justification: this.justification || '',
                dossier: this.dossier['@id']
            }
        );
        this.hydraService
            .post(api.changementComissionSeance, payload)
            .subscribe(res => {
                this.toolService.notificationInfo(
                    'Votre demande a été envoyée',
                    3000
                );
                this.dialogRef.close(payload);
            });
    }

    private initData(dossier: ExDossier) {
        this.dossier = dossier;

        if (dossier.commissionTableau) {
            const datefin = new Date(dossier.commissionTableau.datetimeFin);
            if (datefin < this.now) {
                this.commissionDepasse = true;
            }
        }

        const aideIri = this.hydraService.extractIRI(dossier.aide);
        this.getAide(aideIri).subscribe((res: Aide) => {
            this.aide = res;
            this.getCommissionSeance();
        });

        this.candidat = dossier.candidat as Utilisateur;

    }
}
